.container {
  display: flex;
  gap: var(--spacingMd);
  margin-top: var(--spacingXs);
}

.toggleRow {
  display: flex;
  gap: var(--spacingMd);
  align-items: center;
}
